<template>
  <div
    v-if="
      isPending || relatedArticles.length > 0 || relatedComparePages.length > 0
    "
    class="bg-surface-default-mid py-72"
  >
    <RevContainer>
      <template v-if="isPending">
        <RelatedContentSkeleton v-for="index in 2" :key="index" />
      </template>
      <div v-else class="space-y-48 text-left">
        <ArticleCardsCarousel
          :articles="relatedArticles"
          :title="i18n(translations.relatedArticlesTitle)"
        />
        <ArticleCardsCarousel
          :articles="relatedComparePages"
          :title="i18n(translations.relatedComparePagesTitle)"
        />
      </div>
    </RevContainer>
  </div>
</template>

<script lang="ts" setup>
import { useAsyncData, useRequestURL } from '#imports'
import { computed } from 'vue'

import ArticleCardsCarousel from '@backmarket/nuxt-layer-cms/ArticleCard/ArticleCardsCarousel.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'

import { useFetchInternalLinkCards } from '../../../composables/useFetchInternalLinkCards/useFetchInternalLinkCards'

import translations from './RelatedContent.translations'
import RelatedContentSkeleton from './components/RelatedContentSkeleton.vue'

const i18n = useI18n()
const { pathname } = useRequestURL()
const fetchInternalLinkCards = useFetchInternalLinkCards()
const { data, pending: isPending } = useAsyncData(
  `models-comparison-related-content-${pathname}`,
  fetchInternalLinkCards,
)
const relatedArticles = computed(
  () => data.value?.comparePageRelatedArticles ?? [],
)
const relatedComparePages = computed(
  () => data.value?.comparePageRelatedComparePages ?? [],
)
</script>
